import { createElement, type ReactElement } from "react";
import {
  Apple,
  Baby,
  Beef,
  Boxes,
  Candy,
  Croissant,
  CupSoda,
  Drill,
  Flower2,
  Hammer,
  HeartPulse,
  Lamp,
  Leaf,
  Milk,
  PaintRoller,
  PawPrint,
  Pill,
  Plug,
  Salad,
  Sandwich,
  ShoppingBasket,
  ShowerHead,
  Snowflake,
  Soup,
  Sparkles,
  SprayCan,
  Tag,
  Utensils,
  Wheat,
  Wind,
  type LucideIcon,
} from "lucide-react";
import type { CategoryKey } from "@ainkauf/core";

/**
 * Ein Bildzeichen je Warengruppe.
 *
 * Farbe allein trägt nur so weit: Zwei Grüntöne sehen aus einem Meter
 * Entfernung gleich aus, ein Apfel und ein Brot nicht. Zusammen ergeben Farbe
 * und Zeichen ein Erkennungsbild, das man im Laden im Vorbeigehen liest.
 */
const ZEICHEN: Record<CategoryKey, LucideIcon> = {
  obst_gemuese: Apple,
  backwaren: Croissant,
  fleisch_fisch: Beef,
  theke: Utensils,
  molkerei: Milk,
  wurst_kaese: Sandwich,
  convenience: Soup,
  trockensortiment: Wheat,
  suesswaren: Candy,
  tiefkuehl: Snowflake,
  getraenke: CupSoda,
  drogerie: SprayCan,
  haushalt: Sparkles,
  baby: Baby,
  tier: PawPrint,
  aktion: Tag,
  kasse: ShoppingBasket,
  garten: Flower2,
  bauen_holz: Hammer,
  werkzeug: Drill,
  eisenwaren: Boxes,
  elektro: Plug,
  sanitaer: ShowerHead,
  farben: PaintRoller,
  deko: Lamp,
  asia_frische: Leaf,
  asia_tofu: Salad,
  asia_nudeln_reis: Wheat,
  asia_saucen: Soup,
  beauty: Sparkles,
  haar: Wind,
  gesundheit: HeartPulse,
  ernaehrung: Pill,
};

/**
 * Das Zeichen einer Warengruppe als fertiges Element.
 *
 * Bewusst als Aufruf und nicht als Komponente im JSX: Eine Komponente, die
 * bei jedem Zeichnen frisch aus einer Tabelle gegriffen wird, gilt React als
 * jedes Mal andere Komponente, wird neu eingehängt und verliert ihren
 * Zustand. Hier entsteht direkt das Element.
 */
export function kategorieZeichen(
  category: CategoryKey | "ohne_kategorie" | null,
  size = 16,
  strokeWidth = 2.25,
): ReactElement {
  // Ohne Warengruppe steht der Korb für "kommt noch irgendwo hin".
  const zeichen = category === null || category === "ohne_kategorie" ? ShoppingBasket : ZEICHEN[category];
  return createElement(zeichen, { size, strokeWidth });
}
